"use client";

import { ArrowRight, ShieldCheck, Workflow } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Whyktex() {
  const intro = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const card1 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const card2 = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pillars = [{
    icon: Workflow,
    title: "Global Sourcing",
    description: "Access a vast network of verified international suppliers, streamlining your procurement process with efficient, data-driven trade solutions.",
    reveal: card1,
    delay: "0ms"
  }, {
    icon: ShieldCheck,
    title: "Verified Quality",
    description: "Every transaction is backed by rigorous verification standards, ensuring that your supply chain remains secure, compliant, and reliable.",
    reveal: card2,
    delay: "80ms"
  }];
  return <section data-section-id="18722" id="whyktex" className="bg-white text-[#1a1a1a] border-t-[1.5px] border-[#e0e0e0] py-28 md:py-36">
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-8">
        <div ref={intro.ref} className="mx-auto max-w-3xl text-center transition-all duration-[320ms] ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
        opacity: intro.isVisible ? 1 : 0,
        transform: intro.isVisible ? "translateY(0)" : "translateY(24px)"
      }}>
          <div className="flex items-center justify-center gap-3 md:gap-4">
            <span aria-hidden="true" className="inline-block size-3 md:size-4 bg-[#1a3a52] transition-transform duration-[220ms] ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
            transform: intro.isVisible ? "scale(1)" : "scale(0)"
          }} />
            <h2 className="font-default text-[clamp(2.25rem,4.5vw,4rem)] font-extrabold leading-[0.95] tracking-[-0.025em]">
              Why Choose KTEX?
            </h2>
          </div>
          <p className="font-default mx-auto mt-6 max-w-[56ch] text-[clamp(1.0625rem,1.15vw,1.25rem)] leading-[1.55] text-[#1a1a1a]/70">
            KTEX reimagines global trade by bridging the gap between suppliers and buyers. 
            Our platform provides the transparency, security, and efficiency required 
            to scale your business in today's competitive market.
          </p>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 max-w-5xl mx-auto">
          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div key={i} data-index={i} ref={pillar.reveal.ref} className="bg-white text-[#1a1a1a] border-[1.5px] border-[#e0e0e0] p-10 rounded-lg transition-all duration-[320ms] ease-[cubic-bezier(0.4,0,0.2,1)] flex flex-col" style={{
            opacity: pillar.reveal.isVisible ? 1 : 0,
            transform: pillar.reveal.isVisible ? "translateY(0)" : "translateY(24px)",
            transitionDelay: pillar.reveal.isVisible ? pillar.delay : "0ms",
            boxShadow: "4px 4px 0 0 #e0e0e0"
          }}>
                <Icon className="size-8 stroke-[2] text-[#1a3a52]" aria-hidden="true" />
                <h3 className="font-default mt-8 text-[clamp(1.5rem,2vw,2rem)] font-bold leading-[1.1] tracking-[-0.015em]">
                  {pillar.title}
                </h3>
                <p className="font-default mt-4 text-base leading-[1.6] text-[#1a1a1a]/70">
                  {pillar.description}
                </p>
                <div className="mt-8 pt-2 flex-1 flex items-end">
                  <Link to="#" className="group font-default inline-flex items-center gap-2 text-sm font-bold text-[#1a3a52]">
                    <span aria-hidden="true" className="inline-block size-2 bg-[#d4a574]" />
                    <span className="relative">
                      Learn more
                      <span aria-hidden="true" className="absolute left-0 -bottom-0.5 h-0.5 w-0 bg-[#1a3a52] transition-[width] duration-[220ms] ease-[cubic-bezier(0.4,0,0.2,1)] group-hover:w-full" />
                    </span>
                    <ArrowRight className="size-4 stroke-[2.5] transition-transform duration-[220ms] ease-[cubic-bezier(0.4,0,0.2,1)] group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}